var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 302.27,
    height: 62.055,
    viewBox: "0 0 302.27 62.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3121",
    "data-name": "Rectangle 3121",
    width: 302.27,
    height: 62.055,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10606",
    "data-name": "Group 10606",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28940",
    "data-name": "Path 28940",
    d: "M161.208,17.477h15.815v4.147H166.345v6.569h8.184v4.073h-8.184V43.09h-5.137Z",
    transform: "translate(-22.495 -2.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10605",
    "data-name": "Group 10605",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10604",
    "data-name": "Group 10604",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28941",
    "data-name": "Path 28941",
    d: "M183.172,16.818a3.159,3.159,0,1,1,3.155,3.009,3.013,3.013,0,0,1-3.155-3.009m.551,5.431h5.137V42.578h-5.137Z",
    transform: "translate(-25.56 -1.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28942",
    "data-name": "Path 28942",
    d: "M209.905,32.671c0-3.265-1.8-5.027-4.513-5.027-2.789,0-4.587,1.761-4.587,5.027V43.9h-5.137V23.57H200.8V26.1a7.593,7.593,0,0,1,6.128-2.825c4.733,0,8.109,3.082,8.109,8.7V43.9h-5.137Z",
    transform: "translate(-27.304 -3.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28943",
    "data-name": "Path 28943",
    d: "M231.606,23.234a8.036,8.036,0,0,1,6.715,3.229v-2.9H243.5V43.893h-5.175V40.921a8.016,8.016,0,0,1-6.751,3.3c-5.138,0-9.247-4.221-9.247-10.568s4.11-10.421,9.283-10.421m1.322,4.513c-2.753,0-5.357,2.055-5.357,5.908s2.6,6.054,5.357,6.054c2.826,0,5.393-2.128,5.393-5.981s-2.568-5.981-5.393-5.981",
    transform: "translate(-31.023 -3.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28944",
    "data-name": "Path 28944",
    d: "M267.011,32.671c0-3.265-1.8-5.027-4.513-5.027-2.789,0-4.587,1.761-4.587,5.027V43.9h-5.137V23.57h5.137V26.1a7.593,7.593,0,0,1,6.128-2.825c4.733,0,8.109,3.082,8.109,8.7V43.9h-5.137Z",
    transform: "translate(-35.273 -3.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28945",
    "data-name": "Path 28945",
    d: "M289.482,23.234c5.064,0,8.476,2.642,9.578,7.193h-5.541a3.994,3.994,0,0,0-4.073-2.826c-2.862,0-4.77,2.165-4.77,6.128s1.908,6.091,4.77,6.091a3.878,3.878,0,0,0,4.073-2.789h5.541c-1.1,4.33-4.514,7.192-9.578,7.192-5.871,0-10.054-4.11-10.054-10.494s4.184-10.5,10.054-10.5",
    transform: "translate(-38.992 -3.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28946",
    "data-name": "Path 28946",
    d: "M315.3,44.223c-5.908,0-10.2-4.11-10.2-10.5,0-6.421,4.184-10.494,10.2-10.494,5.871,0,10.017,4,10.017,10.054a12,12,0,0,1-.147,1.982H310.313a4.756,4.756,0,0,0,4.881,4.7,4.187,4.187,0,0,0,4.073-2.458h5.541a9.448,9.448,0,0,1-9.5,6.715m-4.954-12.4H320a4.518,4.518,0,0,0-4.844-4.367,4.721,4.721,0,0,0-4.807,4.367",
    transform: "translate(-42.574 -3.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28947",
    "data-name": "Path 28947",
    d: "M340.552,44.223c-5.1,0-8.66-2.972-8.881-6.751h5.175c.183,1.54,1.614,2.715,3.669,2.715,2.019,0,3.119-.917,3.119-2.092,0-3.633-11.485-1.321-11.485-8.77,0-3.376,3.009-6.091,8.036-6.091,4.918,0,7.89,2.679,8.183,6.715h-4.917c-.147-1.578-1.395-2.642-3.413-2.642-1.909,0-2.9.77-2.9,1.945,0,3.706,11.265,1.394,11.412,8.843,0,3.487-3.046,6.128-8,6.128",
    transform: "translate(-46.282 -3.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28948",
    "data-name": "Path 28948",
    d: "M114.894,32.534c.441-2.679-.808-4.147-3.192-4.147a4.552,4.552,0,0,0-4.661,4.147l-1.981,11.118H98.821L100.8,32.534c.441-2.679-.808-4.147-3.192-4.147a4.552,4.552,0,0,0-4.661,4.147V32.35l-1.981,11.3H84.694l3.595-20.475h6.275l-.441,2.605a8.636,8.636,0,0,1,6.459-2.826c3.119,0,5.394,1.358,6.311,3.853a9.978,9.978,0,0,1,7.6-3.853c5.064,0,7.779,3.229,6.788,8.734L119.15,43.652h-6.238Z",
    transform: "translate(-11.818 -3.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28949",
    "data-name": "Path 28949",
    d: "M131.119,23.212h6.971l2.5,12.806,6.972-12.806h6.788l-18.163,30.2H129.43l6.532-10.421Z",
    transform: "translate(-18.061 -3.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28950",
    "data-name": "Path 28950",
    d: "M47.421,62.055H14.635A14.635,14.635,0,0,1,0,47.421V14.635A14.635,14.635,0,0,1,14.635,0H47.421A14.635,14.635,0,0,1,62.055,14.635V47.421A14.635,14.635,0,0,1,47.421,62.055",
    transform: "translate(0 0)",
    fill: "#6c57f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28951",
    "data-name": "Path 28951",
    d: "M20.944,58.438H17.271V47.318h11.12v3.673a7.446,7.446,0,0,1-7.446,7.446",
    transform: "translate(-2.41 -6.603)",
    fill: "#00f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28952",
    "data-name": "Path 28952",
    d: "M32.43,40.718H17.271V29.6H39.876v3.673a7.446,7.446,0,0,1-7.446,7.446",
    transform: "translate(-2.41 -4.13)",
    fill: "#00f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28953",
    "data-name": "Path 28953",
    d: "M43.88,23H17.271V16.755a4.878,4.878,0,0,1,4.878-4.878H51.326V15.55A7.446,7.446,0,0,1,43.88,23",
    transform: "translate(-2.41 -1.657)",
    fill: "#00f5f5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2093b5ec28d662d1d6a20170cba224dd.svg";
export { ForwardRef as ReactComponent };